// extracted by mini-css-extract-plugin
export default {"appointmentContainer":"Appointment_appointmentContainer__P9MXj","dateWrapper":"Appointment_dateWrapper__O5HwW"};